import { useId, useMemo } from 'react';

/**
 * Generates and maintains a stable ID across renders.
 * Uses React.useId() (React 18+) with an optional caller-provided fallback.
 *
 * @param {string} prefix - Prefix for the generated ID
 * @param {string} [fallbackId] - Optional explicit ID (e.g. props.id)
 * @returns {string}
 */
const useStableId = (prefix, fallbackId) => {
    const reactId = useId();
    const generatedId = useMemo(
        () => `${prefix}-${reactId}`,
        [prefix, reactId]
    );

    return fallbackId || generatedId;
};

export default useStableId;
